export default __webpack_public_path__ + "static/media/aljouf.617e623b.mp4";